module.exports = function () {
    const registerButtons = document.querySelectorAll("a[href*='register-popup']");
    const popup = document.querySelector(".register-popup");
    const popupContent = document.querySelector(".register-popup__content");
    const popupClose = document.querySelector(".register-popup__close");
    const popupIframe = document.querySelector(".register-popup iframe");
    const loader = document.querySelector(".lds-ring");

    if ( registerButtons.length && popup ) {
        let isOpen = false;
        const popupClasses = ["invisible", "opacity-0"];

        registerButtons.forEach(btn => {
            btn.addEventListener("click", (e) => {
                e.preventDefault();
                openPopup();
            })
        })

        popupClose.addEventListener("click", closePopup);

        function openPopup() {
            
            // const iframe = document.querySelector(".lcf-iframe iframe");
            // iframe.setAttribute("src", iframe.dataset.lcfSrc);
            // document.querySelector(".lcf-iframe .lcf-loader")?.classList.add("active");
          
          
            
            popup.classList.remove(...popupClasses);
            document.body.classList.add("overflow-hidden");

            setTimeout(() => {
                document.addEventListener("click", closePopupOutside);
            })

            isOpen = true;
        }

        function closePopup() {
            popup.classList.add(...popupClasses);
            document.body.classList.remove("overflow-hidden");
            document.removeEventListener("click", closePopupOutside);
            isOpen = false;
        }

        function closePopupOutside(e) {
            if ( !popupContent.contains(e.target) ) closePopup();
        }

    
    }
    

 
}